import { all } from "redux-saga/effects";
import {
  loyaltyConfigGetWatcher,
  loyaltyConfigUpdateWatcher,
  loyaltyMemberGetWatcher,
  loyaltyExpiryRowsGetWatcher,
  loyaltyRedeemPreviewWatcher,
  loyaltyOtpRequestWatcher,
  loyaltyOtpVerifyWatcher,
  loyaltyOtpStatusWatcher,
  loyaltyRedeemApplyWatcher,
  loyaltyRedeemReverseWatcher,
  loyaltyAdjustWatcher,
  loyaltyEnrolWatcher,
  loyaltyRuntimeGetWatcher,
} from "../loyalty-saga";

export default function* loyaltyRootSaga() {
  yield all([
    loyaltyConfigGetWatcher(),
    loyaltyConfigUpdateWatcher(),
    loyaltyMemberGetWatcher(),
    loyaltyExpiryRowsGetWatcher(),
    loyaltyRedeemPreviewWatcher(),
    loyaltyOtpRequestWatcher(),
    loyaltyOtpVerifyWatcher(),
    loyaltyOtpStatusWatcher(),
    loyaltyRedeemApplyWatcher(),
    loyaltyRedeemReverseWatcher(),
    loyaltyAdjustWatcher(),
    loyaltyEnrolWatcher(),
    loyaltyRuntimeGetWatcher(),
  ]);
}
